<script setup lang="ts">
import { SellerShopReturnsQuery } from '@gql/SellerShopReturnsQuery'

const t2 = useT2({
  'Download return form': 'Atsisiųsti grąžinimo formą',
})

const seller = useSellerId('retail')

const { ui, loading } = useApolloWrap2<gen.SellerShopReturnsQuery, gen.SellerShopReturnsQueryVariables>(SellerShopReturnsQuery)({
  ui: (i) => i?.publicSeller?.doc?.returnDocs,
  vars: () => {
    const sellerId = seller.value
    return sellerId ? { handle: sellerId } : undefined
  },
})
const props = defineProps<{ autoDownload?: boolean }>()
const elem = useTemplateRef('elem')
const locale = useLocale()

useDelayInit(1000, () => {
  if (props.autoDownload) helpers.getHTMLElement(elem.value)?.click()
})

const link = computed(() => (locale.value === 'lt' ? ui.value?.lt?.original || ui.value?.en?.original : ui.value?.en?.original || ui.value?.lt?.original) ?? undefined)
const name = computed(() => (locale.value === 'lt' ? ui.value?.lt?.filename || ui.value?.en?.filename : ui.value?.en?.filename || ui.value?.lt?.filename) ?? undefined)
</script>

<template>
  <LinkTablet :key="link" ref="elem" :disabled="loading" :to="link" :download="name || 'true'" :txt="t2('Download return form')" :active="false" border external>
    <UiLoading2 v-if="loading" class="_svg16" />
    <svg
      v-else
      class="_svg16"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="7 10 12 15 17 10" />
      <line x1="12" y1="15" x2="12" y2="3" />
    </svg>
  </LinkTablet>
</template>
